module.exports = __webpack_public_path__ + "img/waf-banner.797696d.svg";